import { render, staticRenderFns } from "./PpWalletController.vue?vue&type=template&id=1a06f22e&"
import script from "./PpWalletController.vue?vue&type=script&lang=js&"
export * from "./PpWalletController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports